import React, { useEffect, useState } from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import { connect } from "react-redux";
import { addContactMessageData } from "../../services/backendCalls";
import {ReactComponent as SvgDotPatternIcon} from "../../images/dot-pattern.svg"

const Container = tw.div`relative bg-gray-200`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const FormContainer = styled.div`
  ${tw`p-10 sm:p-12 md:p-16 bg-gray-900 text-gray-100 rounded-lg relative`}
  form {
    ${tw`mt-4`}
  }
  h2 {
    ${tw`text-3xl sm:text-4xl font-bold`}
  }
  input,textarea {
    ${tw`w-full bg-transparent text-gray-100 text-base font-medium tracking-wide border-b-2 py-2 text-gray-100 hocus:border-pink-400 focus:outline-none transition duration-200`};

    ::placeholder {
      ${tw`text-gray-500`}
    }
  }
`;

const TwoColumn = tw.div`flex flex-col sm:flex-row justify-between`;
const Column = tw.div`sm:w-5/12 flex flex-col`;
const Column2 = tw(Column)`lg:pl-24`;
const InputContainer = tw.div`relative py-5 mt-6`;
const Label = tw.label`absolute top-0 left-0 tracking-wide font-semibold text-sm`;
const Input = tw.input``;
const TextArea = tw.textarea`h-24 sm:h-full resize-none`;
const SubmitButton = tw.button`w-full sm:w-32 mt-6 py-3 bg-gray-100 text-red-700 rounded-full font-bold tracking-wide shadow-lg uppercase text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-gray-300 hover:text-primary-700 hocus:-translate-y-px hocus:shadow-xl`;

const SvgDotPattern1 = tw(SvgDotPatternIcon)`absolute bottom-0 right-0 transform translate-y-1/2 translate-x-1/2 -z-10 opacity-50 text-primary-500 fill-current w-24 z-20`

const CComponent = (props) => {
  const heading = props.ContactUsData.heading;
  const formAction = props.ContactUsData.formAction;
  const inputs = props.ContactUsData.inputs;
  const instruction = props.ContactUsData.instruction;
  const messageInput = props.ContactUsData.messageInput;
  const [formValues, setFormValues] = useState({});
  const [statusMessage, setStatusMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const defaults = {};
    (inputs || []).forEach((input) => {
      const name = input?.inputDetails?.name;
      if (name) defaults[name] = "";
    });
    defaults.message = "";
    setFormValues(defaults);
  }, [inputs]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      await addContactMessageData(formValues);
      setStatusMessage("Thanks! Your message has been received.");
      const resetValues = {};
      Object.keys(formValues).forEach((key) => {
        resetValues[key] = "";
      });
      setFormValues(resetValues);
    } catch (error) {
      setStatusMessage("We could not send your message right now.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container>
      <Content>
        <FormContainer>
          <div tw="mx-auto max-w-4xl">
            <h2>{heading}</h2>
            {statusMessage && <p style={{ color: '#34d399', marginTop: 12 }}>{statusMessage}</p>}
            <form action={formAction} onSubmit={handleSubmit}>
              <TwoColumn>
                <Column>
                  {inputs.map((input, index) => (
                    <InputContainer key={index}>
                    <Label htmlFor={input.labelDetails.htmlFor}>{input.labelDetails.innerHtml}</Label>
                    <Input id={input.inputDetails.id} type={input.inputDetails.type} name={input.inputDetails.name} placeholder={input.inputDetails.placeholder} value={formValues[input.inputDetails.name] || ""} onChange={handleChange} />
                  </InputContainer>
                  ))}
                  <InputContainer tw="flex-1">
                    <Label htmlFor="message-input">Your Message</Label>
                    <TextArea id="message-input" name="message" placeholder={messageInput.placeholder} value={formValues.message || ""} onChange={handleChange} />
                  </InputContainer>
                </Column>
                <Column2>  
                  {instruction}
                </Column2>
              </TwoColumn>

              <SubmitButton type="submit" value="Submit" disabled={isSubmitting}>{isSubmitting ? "Submitting..." : "Submit"}</SubmitButton>
            </form>
          </div>
          <SvgDotPattern1 />
        </FormContainer>
      </Content>
    </Container>
  );
};


const ContactUs = connect((state) => ({
  ContactUsData: state.ContactUsData
}))(CComponent);

export default ContactUs;